import React from 'react';
import MilestoneReport from './MilestoneReport';
import './MilestoneReport.scss';

const MilestoneReportMain = () => (
  <div className="milestone-report-wrapper">
    <div className="milestone-report-content">
      <MilestoneReport />
    </div>
  </div>
);

export default MilestoneReportMain;
